import React, { FC } from 'react';
import { NewProject } from 'assets/images/led';
import { alpha, Box, Button, Grid, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { LedSubmitButton } from 'components/led/atoms';
interface ProjectSectionProps {
  title: string;
  description: string;
  button: string;
  secondButton?: string;
  onClick: () => void;
  onContinue?: () => void;
  loading?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  firstBlock: {
    backgroundColor: theme.palette.common.white,
    width: '100%',
    borderRadius: theme.spacing(3),
    boxShadow: `0 17px 40px -10px ${alpha(theme.palette.common.black, 0.1)}`,
    marginBottom: theme.spacing(10),
    padding: theme.spacing(0, 4),
  },
  imageProject: {
    marginTop: theme.spacing(-15),
  },
  textProject: {
    maxWidth: 623,
    marginBottom: theme.spacing(6),
  },
  buttonProject: {
    marginBottom: theme.spacing(8),
  },
  secondButton: {
    marginLeft: 0,
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(4),
    },
  },
}));

const ProjectSection: FC<ProjectSectionProps> = ({
  title,
  button,
  secondButton,
  description,
  onClick,
  loading,
  onContinue,
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.firstBlock}>
      <Grid container justifyContent={'center'} direction={'row'}>
        <Grid item>
          <img src={NewProject} alt="NewProject" className={classes.imageProject} />
        </Grid>
      </Grid>
      <Box mb={2} pt={2.5}>
        <Typography variant="h2" align="center">
          {title}
        </Typography>
      </Box>
      <Grid container justifyContent="center">
        <Grid className={classes.textProject} item>
          <Typography align="center" variant="body2">
            {description}
          </Typography>
        </Grid>
      </Grid>
      <Grid container justifyContent="center">
        <Grid item className={classes.buttonProject}>
          <LedSubmitButton
            color={'primary'}
            variant={'contained'}
            loading={loading}
            onClick={onClick}
          >
            {button}
          </LedSubmitButton>
        </Grid>
        <Grid item className={classes.buttonProject}>
          {secondButton && (
            <Button
              color={'secondary'}
              variant={'outlined'}
              className={classes.secondButton}
              onClick={onContinue}
            >
              {secondButton}
            </Button>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProjectSection;
